import React from 'react';
import { BaseComponent } from '../../../../components/BaseComponent';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { FormField } from '../../../../components/FormFields';
import { Input } from '../../../../components/Input';
import { HBox, VBox } from '../../../../components/Box';
import { Button } from '../../../../components/Buttons';
import { Modal } from '../../../../components/Modal';
import { Checkbox } from '../../../../components/Checkbox';
import { Loader } from '../../../../components/Loader';
import s from './QuickCreatorModal.module.css';

import ModalComponent from '../../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';

const Container = styled.div`
  width: 100%;

  .field-block {
    margin-bottom: 8px;
    white-space: nowrap;
    .label {
      width: 60%;
    }
  }

  .checkbox-wrapper {
    strong {
      font-weight: 500;
    }
  }
`;

const STATE = {
  string: null,
  result: null,
};

/* eslint-disable react/prefer-stateless-function */
class UserQuickCreatorModalComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  save() {
    this.props.onSave();
  }

  reset() {
    this.props.onCancel();
  }

  onUserInputChange(evt) {
    const { name, value } = evt.target;
    this.props.setUser(name, value);
  }

  onCheckRole(role) {
    this.props.setRole(role);
  }

  render() {
    return (
      <ModalComponent
        className={s.modalComponent}
        title={this.lbl('company.details.create_user')}
        onClose={this.reset.bind(this)}
      >
        <div className={s.container}>
          <label className="form-label">{this.lbl('user.details.name')}</label>
          <input
            className="form-control"
            name="name"
            value={this.props.newUser?.name ?? ''}
            placeholder={'name'}
            onChange={this.onUserInputChange.bind(this)}
          />
        </div>

        <div className={s.container}>
          <label className="form-label">{this.lbl('user.details.surname')}</label>
          <input
            className="form-control"
            name="surname"
            value={this.props.newUser?.surname ?? ''}
            placeholder={'surname'}
            onChange={this.onUserInputChange.bind(this)}
          />
        </div>

        <div className={s.container}>
          <label className="form-label">{this.lbl('user.details.email_address')}</label>
          <input
            className="form-control"
            name="email_address"
            value={this.props.newUser?.email_address ?? ''}
            placeholder={'email_address'}
            onChange={this.onUserInputChange.bind(this)}
          />
        </div>

        <div className={s.container}>
          <label className="form-label">{this.lbl('user.details.phone')}</label>
          <input
            className="form-control"
            name="phone"
            value={this.props.newUser?.phone ?? ''}
            placeholder={'phone'}
            onChange={this.onUserInputChange.bind(this)}
          />
        </div>

        {/* <HBox className="field-block">
            <strong className="label">{this.lbl('user.create.modal.type_of_contact')}</strong>
            <VBox className="checkbox-wrapper">
              <FormField>
                <Checkbox
                  checked={this.props.roles?.financial_contact == '1'}
                  onChange={() => this.onCheckRole('financial_contact')}
                >
                  <strong>{this.lbl('company.users.role.financial_contact')}</strong>
                </Checkbox>
              </FormField>
              <FormField>
                <Checkbox
                  checked={this.props.roles?.commercial_contact == '1'}
                  onChange={() => this.onCheckRole('commercial_contact')}
                >
                  <strong>{this.lbl('company.users.role.commercial_contact')}</strong>
                </Checkbox>
              </FormField>
              <FormField>
                <Checkbox
                  checked={this.props.roles?.document_contact == '1'}
                  onChange={() => this.onCheckRole('document_contact')}
                >
                  <strong>{this.lbl('company.users.role.document_contact')}</strong>
                </Checkbox>
              </FormField>
            </VBox>
          </HBox> */}
        <div className="d-flex gap-2">
          <ButtonComponent style={'ButtonSoftDelete'} onClick={this.reset.bind(this)}>
            {this.lbl(`cancel`)}
          </ButtonComponent>
          <ButtonComponent
            disabled={!this.props.newUser?.email_address || this.props.workCreate}
            style={'ButtonSoftEdit'}
            onClick={this.save.bind(this)}
          >
            {this.props.workCreate ? <Loader small /> : this.lbl(`confirm`)}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }
}

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const UserQuickCreatorModal = compose(withConnect, withRouter)(UserQuickCreatorModalComp);
